import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-overdue-debt',
  templateUrl: './overdue-debt.component.html',
  styleUrls: ['./overdue-debt.component.scss']
})
export class OverdueDebtComponent implements OnInit {
  url: string = 'https://app.powerbi.com/view?r=eyJrIjoiZTE1YTk3NDUtYzJiNS00MjRhLWI4ODMtYzU5NTg2YTQ0NDM2IiwidCI6ImNkZDY0NWJmLTE3MzEtNGQzNy05Mjc1LThiOWEwZjNlZTYwNCIsImMiOjEwfQ%3D%3D';
  urlSafe: SafeResourceUrl;

  constructor(
    public sanitizer: DomSanitizer
  ){}

  ngOnInit() {
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

}



// WEBPACK FOOTER //
// /opt/app/src/app/features/power-bi-dashboard/overdue-debt/overdue-debt.component.ts